import React from 'react';
import styles from './VendorStoreModal.module.css';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import cancelIcon from 'routes/vendorRe/images/cancel_icon.png';
import P from 'components/P';

// 스타일 변수
const fontSize = 'max(1vw, 10px)';
const paddBottom = '0 0 1vw';

const VendorStoreModal = ({ callbackFn }) => {
    return (
        <div className={styles.layer}>
            <div className={styles.popup}>
                <Container padding="1vw">
                    <HorizontalFlex>
                        <FlexChild
                            justifyContent="flex-end"
                            padding={paddBottom}
                        >
                            <img
                                className={styles.cancel}
                                onClick={() => {
                                    if (callbackFn) {
                                        callbackFn();
                                    }
                                }}
                                src={cancelIcon}
                                alt="취소 아이콘"
                            />
                        </FlexChild>
                    </HorizontalFlex>
                    <HorizontalFlex
                        backgroundColor="white"
                        gap="1vw"
                        alignItems="flex-start"
                        padding="1vw"
                    >
                        <FlexChild>
                            <VerticalFlex>
                                <FlexChild alignItems="flex-start">
                                    <P size={fontSize} padding={paddBottom}>
                                        정산번호
                                    </P>
                                    <P size={fontSize}>A20240204</P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex>
                                <FlexChild alignItems="flex-start">
                                    <P size={fontSize} padding={paddBottom}>
                                        정산일
                                    </P>
                                    <P size={fontSize}>24-03-28</P>
                                    <P size={fontSize}>12:22:03</P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex>
                                <FlexChild alignItems="flex-start">
                                    <P size={fontSize} padding={paddBottom}>
                                        실 입금 금액
                                    </P>
                                    <P size={fontSize}>325,000</P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex>
                                <FlexChild alignItems="flex-start">
                                    <P size={fontSize} padding={paddBottom}>
                                        입금 상태
                                    </P>
                                    <P size={fontSize}>입금 대기</P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex>
                                <FlexChild alignItems="flex-start">
                                    <P size={fontSize} padding={paddBottom}>
                                        은행명
                                    </P>
                                    <P size={fontSize}>하나은행</P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </Container>
            </div>
        </div>
    );
};

export default VendorStoreModal;
